/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {Post, GetRequest} from '@/api/request';
import Loading from '@/assets/icons/Loading.gif';
import closeFolderIcon from '@/assets/icons/usb/closeFolder.svg';
import noFolderListIcon from '@/assets/icons/usb/noFolderList.svg';
import openFolderIcon from '@/assets/icons/usb/openFolder.svg';
import ListExplorer from '@/components/explorer/explorerView/listExplorer/ListExplorer';
import ToggleButton from '@/components/togglebutton/ToggleButton';
import Tree from '@/components/tree/Tree';
import {ALERT_TYPE} from '@/constants/enums';
import {EXPORT_IMPORT} from '@/constants/messages';
import * as APPDATA from '@/constants/pcConstAppData';
import {IsEmpty} from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import './UsbFolderList.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  selectedFile: store.setupStore.selectedFileExport,
  usbProperties: store.setupStore.usbProperties,
  usbOpenFor: store.setupStore.usbOpenFor,
}))
class USBFolderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      folderList: [],
      dataState: -1,
      currentDrive: 0,
      selectedFolder: {},
    };
    this.successCopyFile = this.successCopyFile.bind(this);
    this.errorCopyFile = this.errorCopyFile.bind(this);
    this.failedCopyFile = this.failedCopyFile.bind(this);
  }

  // --------------------------- End Component Will Receive Props ------------
  componentDidMount() {
    this._ismounted = true;

    consoleLog('USB folder list componentDidMount ', this.props);
    if (this.props.selectedFile.length === 0) this.goToCycleHistory();
    else {
      this.props.dispatch(setupActions.updateActiveMenu(APPDATA.SELECT_FOLDER));

      this.getFolderList(this.props.usbProperties[0].Path);
      // var label = this.props.usbProperties === undefined ? "" : this.props.usbProperties.Label;
      this.setState({dataState: ListExplorer.state.WAITING_DATA});
    }
    this.setTopMenuProperties(false, APPDATA.SELECT_FOLDER);
  }

  // ------------------------------ Coponent WIll Receive Props ---------------
  UNSAFE_componentWillReceiveProps(nextProps) {
    consoleLog('componentWillReceiveProps', nextProps);
  }

  componentWillUnmount() {
    this._ismounted = false;
    // resetSelectedFile
    this.props.dispatch(setupActions.selectedFileExport([]));
    // this.props.dispatch(setupActions.selectedFolderExportDestination(undefined));
    this.props.dispatch(setupActions.usbProperties(undefined));
  }

  setTopMenuProperties = (disabledMainButton, titleMenu) => {
    const topButtonProperties = {
      id: APPDATA.EXPORT,
      label: APPDATA.EXPORT,
      onClick: this.onClickTopMenu,
      disabled: disabledMainButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.onClickTopMenu,
    };
    const titleMenuProperties = titleMenu;

    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  onClickTopMenu = (e) => {
    const {selectedFolder, currentDrive} = this.state;
    const {selectedFile, usbProperties} = this.props;
    switch (e.currentTarget.id) {
      case APPDATA.EXPORT: {
        consoleLog('onClick Export', {selectedFile, selectedFolder, usbProperties, currentDrive});
        let destinationPath;
        if (selectedFile.length > 0 && selectedFolder.Path !== undefined) {
          consoleLog('copy to folder', selectedFolder.Path);
          destinationPath = selectedFolder.Path;
        } else if (selectedFile.length > 0) {
          consoleLog('copy to root', usbProperties[currentDrive].Path);
          destinationPath = usbProperties[currentDrive].Path;
        }
        this.setState(() => {
          this.copyFileLog(selectedFile, destinationPath);
        });
        break;
      }
      case APPDATA.BACK:
        this.goToCycleHistory();
        break;
      default:
        break;
    }
  };

  // eslint-disable-next-line class-methods-use-this
  generateBottomMenu = () => <div className="usbFolderListBottom center footer" />;

  goToCycleHistory = () => {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.CYCLE_HISTORY));
    window.location.href = APPDATA.CYCLE_HISTORY_ADDRESS;
  };

  // ------------------------- Get Folder List ------------------------------
  folderTreeChild = ({folder, keyParent}) => {
    const directories = [];
    // consoleLog("folderTreeChild", folder);
    for (let id = 0; id < folder.length; id++) {
      let directory = {};
      let key;
      if (keyParent === undefined) {
        key = id;
      } else {
        key = `${keyParent}-${id}`;
      }

      let content = [];
      if (folder[id].Content.length > 0)
        content = this.folderTreeChild({folder: folder[id].Content, keyParent: key.toString()});
      directory = {
        key: key.toString(),
        Path: folder[id].Path,
        label: folder[id].Label,
        icon: closeFolderIcon,
        hasChildIcon: openFolderIcon,
        children: content,
        childVisible: false,
        isActive: false,
      };
      directories.push(directory);
    }
    return directories;
  };

  // eslint-disable-next-line react/sort-comp
  successGetFolderList(response) {
    const {details, message} = response.data;

    if (!IsEmpty(message)) {
      this.failedsGetFolderList();
      return;
    }

    const folderList = this.folderTreeChild({folder: details});
    if (this._ismounted) {
      this.setState({
        folderList,
        dataState: ListExplorer.state.AVAILABLE_DATA,
      });
    }
  }

  /**
   * action handler when failed to get folder structure of selected usb drive storage
   */
  failedsGetFolderList = () => {
    if (this._ismounted) {
      this.setState({dataState: ListExplorer.state.NO_DATA});
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND,
          alertStyle: ALERT_TYPE.ALERT_DANGER,
        }),
      );
      window.location.href = APPDATA.CYCLE_HISTORY_ADDRESS;
    }
  };

  getFolderList = (path) => {
    if (this.props.usbProperties !== undefined) {
      switch (this.props.usbOpenFor) {
        case APPDATA.USB_OPEN_FOR.EXPORT_CYCLE_HYSTORY: {
          const params = {
            params: {
              path,
              level: -1,
            },
          };
          GetRequest(APPDATA.API.GET_FOLDER_STRUCTURE, params).then((response) => this.successGetFolderList(response));

          break;
        }
        default:
          break;
      }
    } else {
      consoleLog('usb undefined');
    }
  };
  // --------------------- End Get Folder List ------------------------------

  // --------------------- send path folder ---------------------------------
  copyFileLog = (source, destination) => {
    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.PROFILE_HISTORY.EXPORTING_PROFILE_HISTORY,
        loadingClickEvent: undefined,
        loadingButton1: undefined,
        // {
        // 	label: APPDATA.CLOSE,
        // 	onClick: () => {
        // 		this.props.dispatch(loadingActions.showLoading(false));
        // 	},
        // },
      }),
    );
    // The profile history exported as csv file with default file name
    // µPULSE_AutoProfileConcentrate_03-01-2020.csv (based on profile history name)
    // And if there is existing file with same name as default name, it will be added (1). For example µPULSE_ProfileHistory_12-01-20_12;00(1).rar

    const multipleFiles = source.map((file) => ({
      FileName: file.ExportFileName,
      SourcePath: file.Path,
    }));
    const param = {
      Files: multipleFiles,
      DestinationPath: destination,
    };
    consoleLog('copyFileLog to destination folder', param);
    Post(
      APPDATA.API.POST_EXPORT_MULTIPLE_CYCLE_HISTORY,
      param,
      this.successCopyFile,
      param,
      this.errorCopyFile,
      this.failedCopyFile,
    );
  };

  successCopyFile = (response, passingVariabel) => {
    // finish copy log
    consoleLog('successCopyFile', {response, passingVariabel});

    this.setState(() => {
      this.props.dispatch(loadingActions.showLoading(false));
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.PROFILE_HISTORY.SUCCESS_EXPORT,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
        }),
      );
      this.goToCycleHistory();
    });
  };

  failedCopyFile = (response, passingVariabel) => {
    consoleLog('failedCopyFile', {response, passingVariabel});
    this.props.dispatch(loadingActions.showLoading(false));
    let message = APPDATA.MESSAGES.PROFILE_HISTORY.ERROR_EXPORT;
    if (response.data.message === 'Failed Copy Log' && response.data.details.includes('DiskFull')) {
      message = APPDATA.MESSAGES.PROFILE_HISTORY.ERROR_EXPORT_STORAGE_FULL;
    } else if (response.data.message === 'Failed Copy Log' && response.data.details.includes('PathNotFound')) {
      message = APPDATA.MESSAGES.EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND;
    }
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
    this.goToCycleHistory();
  };

  errorCopyFile = (error, passingVariabel) => {
    consoleLog('errorCopyFile', {error: error.response, passingVariabel});
    this.props.dispatch(loadingActions.showLoading(false));
    let message = APPDATA.MESSAGES.PROFILE_HISTORY.ERROR_EXPORT;
    if (error.response.data.message === 'Failed Copy Log' && error.response.data.details.includes('DiskFull')) {
      message = APPDATA.MESSAGES.PROFILE_HISTORY.ERROR_EXPORT_STORAGE_FULL;
    } else if (
      error.response.data.message === 'Failed Copy Log' &&
      error.response.data.details.includes('PathNotFound')
    ) {
      message = APPDATA.MESSAGES.EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND;
    }
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
    this.goToCycleHistory();
    // failed send path
  };

  //---------------------------------------------------------------------------------------
  updateFolderTree = ({folder, selectedKey}) => {
    const directories = [];
    // consoleLog("updateFolderTree", folder);
    for (let id = 0; id < folder.length; id++) {
      let directory = {};
      let content = [];
      const isChildVisible =
        folder[id].children.length > 0 &&
        (folder[id].key === selectedKey ? !folder[id].childVisible : folder[id].childVisible);

      const activeFolder = folder[id].key === selectedKey;
      if (folder[id].children.length > 0) content = this.updateFolderTree({folder: folder[id].children, selectedKey});
      directory = {
        ...folder[id],
        children: content,
        childVisible: isChildVisible,
        isActive: activeFolder,
      };
      directories.push(directory);
    }
    return directories;
  };

  onClickFolder = (folder) => {
    const {folderList} = this.state;
    consoleLog('onclick folder', folder);
    let tempTree = [];
    const selectFolder = {
      Path: folder.Path,
      key: folder.key,
      label: folder.label,
    };

    tempTree = this.updateFolderTree({folder: folderList, selectedKey: folder.key});

    this.setState(
      {
        folderList: tempTree,
        selectedFolder: selectFolder,
      },
      () => {
        // consoleLog("onClickFolder", this.state);
        // if (this.state.selectedFolder !== {}) this.setTopMenuProperties(false, APPDATA.SELECT_FOLDER);
      },
    );
  };

  onClickChangeUSB = (e) => {
    this.setState(
      {
        currentDrive: e.currentTarget.id,
        dataState: ListExplorer.state.WAITING_DATA,
        selectedFolder: {},
      },
      () => {
        const params = {
          params: {
            path: this.props.usbProperties[this.state.currentDrive].Path,
            level: -1,
          },
        };
        GetRequest(APPDATA.API.GET_FOLDER_STRUCTURE, params).then((response) => this.successGetFolderList(response));
      },
    );
  };

  renderView = () => {
    // handle not set  data state. because default data state is ListExplorer.state.AVAILABLE_DATA
    const {dataState, folderList} = this.state;
    let tempDataState = dataState;
    if (tempDataState === ListExplorer.state.AVAILABLE_DATA) {
      if (folderList === undefined) tempDataState = -1;
      else if (folderList.length === 0) tempDataState = ListExplorer.state.NO_DATA;
    }

    switch (tempDataState) {
      case ListExplorer.state.WAITING_DATA:
        return (
          <div className="folderLoading">
            <img
              className="loadingIcon"
              src={Loading}
              alt={Loading}
              width={125}
              height={125}
            />
            <br />
            <span>Please Wait!</span>
          </div>
        );
      case ListExplorer.state.NO_DATA:
        return (
          <div className="notFoundFolderList">
            <img
              src={noFolderListIcon}
              alt={noFolderListIcon}
              className="wifiDisableIcon"
            />
            <div className="text">
              <span>No folder found</span>
            </div>
          </div>
        );
      case ListExplorer.state.AVAILABLE_DATA:
        return (
          <div className="folderTreeList">
            <Tree
              data={folderList}
              callbackOnClick={this.onClickFolder}
            />
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    const style = {
      constraint: {
        fontSize: this.props.fontSize,
      },
    };
    const {usbProperties} = this.props;
    const {currentDrive} = this.state;
    const usbDriveButtonProp = [];
    let divUsbDriveBottonClassName = 'col-md-12';
    if (usbProperties !== undefined) {
      for (let id = 0; id < usbProperties.length; id++) {
        const tempUsbDriveButtonProp = {
          label: usbProperties[id].Label,
          value: id,
          id,
          onClick: this.onClickChangeUSB,
        };
        usbDriveButtonProp[id] = tempUsbDriveButtonProp;
      }
      switch (usbProperties.length) {
        case 1:
          divUsbDriveBottonClassName = 'col-md-3';
          break;
        case 2:
          divUsbDriveBottonClassName = 'col-md-6';
          break;
        case 3:
          divUsbDriveBottonClassName = 'col-md-9';
          break;
        default:
          divUsbDriveBottonClassName = 'col-md-12';
          break;
      }
    }
    return (
      <div
        style={style.constraint}
        className="usbFolderPage"
      >
        <div className="rowHeightToggleButton middleAlign ">
          <div className={`${divUsbDriveBottonClassName} toggleProfileType`}>
            <ToggleButton
              buttonProp={usbDriveButtonProp}
              defaultValue={currentDrive}
              value={currentDrive}
              onClick={this.onClickChangeUSB}
            />
          </div>
        </div>
        {this.renderView()}
        {this.generateBottomMenu()}
      </div>
    );
  }
}
export default USBFolderList;
